module.exports = __webpack_public_path__ + "img/pic-19.842fa3e6.jpg";